<section class="video-section shape-style-one section-gap">
    <div class="container-fluid">
        <div class="row align-items-center justify-content-between">
            <div class="col-xl-4 col-lg-4 col-md-12 order-2 order-md-1">
                <img src="assets/img/img1Sec4.png" alt="Sello">
            </div>
            <div class="col-xl-4 col-lg-4 col-md-6 order-2 order-md-1">
                <div class="video-text">
                    <div class="section-title left-border mb-30">
                        <h2 class="title">
                            ¿Por qué Carne Angus <br> Certificada Mexicana?
                        </h2>
                    </div>
                    <p><img src="assets/img/check.png" alt=""> &nbsp;La certificadora de la AAM es la única en México que otorga el sello.</p>
                    <p><img src="assets/img/check.png" alt=""> &nbsp;Ventaja estratégica de la marca y de la raza.</p>
                    <p><img src="assets/img/check.png" alt=""> &nbsp;Es nacional y hecho por mexicanos.</p>
                    <a routerLink="/contact" class="main-btn main-btn-4">Obtener certificado</a>
                </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-6 order-2 order-md-1">
                <img src="assets/img/img2Sec4.png" alt="Meat">
            </div>
        </div>
        <section id="Beneficios"></section>
    </div>
</section>